import React, { FC } from 'react'
import { NavLink } from 'react-router-dom'
import styled from '@emotion/styled'
import copy from 'copy-to-clipboard'

import { useAuth } from 'core/auth'
import { useLoginModal, useMemoizedFn } from 'shared/hooks'
import { stringOmitMiddle } from 'shared/utils'

import { Popover } from 'antd'
import { LoginModal } from 'components'

import logo from './assets/logo.png'
import wallet from './assets/wallet.png'
import ImageCopy from './assets/copy.png'

export const Header: FC = () => {
    const {
        methods: { show }
    } = useLoginModal()

    const {
        account,
        methods: { disconnect }
    } = useAuth()

    const handleConnect = useMemoizedFn(() => {
        if (account) return
        show()
    })

    return (
        <HeaderWrapper className="flex justify-center items-center overflow-hidden">
            <HeaderContent>
                <NavLink className="mr-0 md:mr-8" to="/">
                    <img className="logo" src={logo} alt="" />
                </NavLink>
                {account ? (
                    <Popover
                        content={
                            <>
                                <MenuItem>
                                    <div className="flex items-center">
                                        <div>{stringOmitMiddle(5, 5, account)}</div>
                                        <img
                                            className="cursor-pointer"
                                            src={ImageCopy}
                                            alt=""
                                            onClick={() => copy(account)}
                                            style={{ width: 16, height: 16, marginLeft: 18 }}
                                        />
                                    </div>
                                </MenuItem>
                                <MenuItem className="cursor-pointer" onClick={disconnect}>
                                    Disconnect Wallet
                                </MenuItem>
                            </>
                        }
                    >
                        <div className="flex items-center">
                            <img className="wallet" src={wallet} alt="" />
                            <Account>{stringOmitMiddle(5, 5, account)}</Account>
                        </div>
                    </Popover>
                ) : (
                    <img className="cursor-pointer wallet" src={wallet} alt="" onClick={handleConnect} />
                )}
            </HeaderContent>
            <LoginModal />
        </HeaderWrapper>
    )
}

const MenuItem = styled.div`
    font-family: Roboto-Medium;
    font-size: 16px;
    color: #ffffff;
    line-height: 36px;
`

const Account = styled.span`
    margin-left: 6px;
    font-family: Roboto-Regular;
    font-size: 16px;
    color: #fff;
`

const HeaderWrapper = styled.header`
    width: 100%;
    height: 68px;
    background-color: #2f2e2e;
`

const HeaderContent = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 98%;
    height: 100%;
    margin: 0 auto;
    @media (min-width: 640px) {
        max-width: 684px;
    }
    @media (min-width: 768px) {
        max-width: 812px;
    }
    @media (min-width: 1024px) {
        max-width: 1068px;
    }
    @media (min-width: 1280px) {
        max-width: 1324px;
    }
    @media (min-width: 1440px) {
        max-width: 1330px;
    }
    .logo {
        width: 164px;
        height: auto;
        user-select: none;
    }
    .wallet {
        width: 24px;
        height: auto;
        user-select: none;
    }
`
